import apiClient from './apiClient';

/** O que voltou do envio: para quem foi, e para quem não foi e por quê. */
export interface ResultadoDoEnvio {
  enviados: { funcionario: string; documentoId: number }[];
  naoEnviados: { funcionario: string; motivo: string }[];
}

function corpo(resposta: unknown): ResultadoDoEnvio {
  const r = resposta as Partial<ResultadoDoEnvio> | undefined;
  return { enviados: r?.enviados ?? [], naoEnviados: r?.naoEnviados ?? [] };
}

/** Manda o ASO ou a Ordem de Serviço para o funcionário assinar pelo celular. */
class EnvioAoFuncionarioService {
  async aso(medicalRecordId: number): Promise<ResultadoDoEnvio> {
    return corpo(await apiClient.post(`/medical-records/${medicalRecordId}/aso/assinatura`));
  }

  async ordemDeServico(emissaoId: number): Promise<ResultadoDoEnvio> {
    return corpo(await apiClient.post(`/documents/emissions/${emissaoId}/assinatura`));
  }
}

export const envioAoFuncionarioService = new EnvioAoFuncionarioService();
export default envioAoFuncionarioService;
